<template>
  <div class="block block-rounded">
    <div class="block-header block-header-default">
      <h3 class="block-title">Settings</h3>
    </div>
    <div>
      <div class="block-content block-content-full">
        <loadingspinner v-if="loading"></loadingspinner>
        <div v-else>
          <div
            v-if="currentSettings.xero_connected"
            class="alert alert-success"
          >
            Xero Connected
          </div>
          <div v-else class="alert alert-danger">
            Xero Not Connected
            <span v-if="currentSettings.xero_reason">
              &mdash; {{ currentSettings.xero_reason }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useFetch } from "@/components/useFetch.js";
import loadingspinner from "@/components/form/loadingspinner.vue";

const currentSettings = ref([]);

const loading = ref(true);

const urlToFetch = new URL(route("api.settings.index"));

async function getSettings() {
  loading.value = true;
  const response = await useFetch(urlToFetch);
  currentSettings.value = await response.json();
  loading.value = false;
}

getSettings();
</script>
